module.exports = __webpack_public_path__ + "img/G-Suite.f031994c.png";